import { inject, Injectable, InjectionToken } from '@angular/core';
import { Router } from '@angular/router';

import { FormatsContextAware } from './formats-context-aware';

export const FORMAT_NAVIGATOR_SERVICE = new InjectionToken<FormatsNavigatorService>('FORMAT_NAVIGATOR_SERVICE');

/**
 * Single implementation of format navigation shared by the standalone `formats` app and the `formats-embed`
 * app (both the "my organization" and "administration" contexts). The target route differs per `FORMATS_CONTEXT`,
 * while the tenant resolution is delegated to `FormatsContextAware.getTenantId()` so it stays consistent with the
 * other formats services.
 */
@Injectable()
export class FormatsNavigatorService extends FormatsContextAware {
  private router = inject(Router);

  public openFormat(formatId: number): void {
    switch (this.context) {
      case 'EMBED_ORGANIZATION_ADMINISTRATION':
        this.router.navigate([`/administration/accounts/${this.getTenantId()}/configuration/formats`, formatId]);
        break;
      case 'EMBED_MY_PROFILE':
        this.router.navigate([`/global-configuration/formats/${this.getTenantId()}/format`, formatId]);
        break;
      case 'EMBED_GLOBAL_ADMINISTRATION':
        this.router.navigate(['/administration/processing/base-formats', formatId]);
        break;
      case 'FORMATS_APP':
        this.router.navigate(['/format', formatId]);
        break;
      default:
        throw new Error(`FormatsNavigatorService: unknown context "${this.context}"`);
    }
  }

  public openListView(): void {
    switch (this.context) {
      case 'EMBED_ORGANIZATION_ADMINISTRATION':
        this.router.navigate([`/administration/accounts/${this.getTenantId()}/configuration/formats`]);
        break;
      case 'EMBED_MY_PROFILE':
        this.router.navigate([`/global-configuration/formats`, this.getTenantId()]);
        break;
      case 'EMBED_GLOBAL_ADMINISTRATION':
        this.router.navigate(['/administration/processing/base-formats']);
        break;
      case 'FORMATS_APP':
        this.router.navigateByUrl('/home');
        break;
      default:
        throw new Error(`FormatsNavigatorService: unknown context "${this.context}"`);
    }
  }
}
